import {MAP_ADDRESS_SOURCE_ID, MAP_ADDRESS_CLUSTER_LAYER, CLUSTER_BLUE_COLOR, MAP_ADDRESS_CLUSTER_SYMBOL_LAYER, MAP_ADDRESS_UNCLUSTER_LAYER} from '@/data/variables'
import { createMapClusterMarkersSource, createMapClustersLayer, createMapUnclusteredAddressImage, createMapClusterCountsLayer } from '@/helpers/map'

export default {
    computed: {
        getAddresses() {
            return this.$store.getters.getAddresses
        }
    },
    methods: {
        addClientsAddressesToMap() {
            const map = this.map;
            if (map.getSource(MAP_ADDRESS_SOURCE_ID)) {
                map.removeLayer(MAP_ADDRESS_CLUSTER_LAYER);
                map.removeLayer(MAP_ADDRESS_UNCLUSTER_LAYER);
                map.removeLayer(MAP_ADDRESS_CLUSTER_SYMBOL_LAYER);
                map.removeSource(MAP_ADDRESS_SOURCE_ID);
            }
            map.addSource(MAP_ADDRESS_SOURCE_ID, createMapClusterMarkersSource(this.getAddresses));
            map.addLayer(createMapUnclusteredAddressImage(MAP_ADDRESS_UNCLUSTER_LAYER, MAP_ADDRESS_SOURCE_ID));
            map.addLayer(createMapClustersLayer(MAP_ADDRESS_CLUSTER_LAYER, MAP_ADDRESS_SOURCE_ID, CLUSTER_BLUE_COLOR));
            map.addLayer(createMapClusterCountsLayer(MAP_ADDRESS_CLUSTER_SYMBOL_LAYER, MAP_ADDRESS_SOURCE_ID));
        },
        getClientStatus(statusId) {
            let status;
            switch (statusId) {
                case 2:
                    return status = this.$t('legend-green');
                    break;
                case 3:
                    return status = this.$t('legend-red');
                    break;
                case 4:
                    return status = this.$t('legend-gray');
                    break;
                case 5:
                    return status = this.$t('legend-stop--red');
                    break;
                case 6:
                    return status = this.$t('legend-stop--green');
                    break;
                case 7:
                    return status = this.$t('legend-upload-address');
                    break;
                default:
                    break;
            }
        },
        createClientAddressModal(event, layer, rulerControl) {
            if (rulerControl.isMeasuring) {
                //ignore opening modals if measuring in progress
                return
            }

            let {features, coordinates} = this.getModalData(event, layer);
            let {name, first_name, last_name, phone_number, address, status} = features.properties;
            let output =
            `<div class="popup">
                    <div class="popup__name">${this.$t('markerInfo')}</div>
                    <div class="popup__title"><b>${this.$t('markerStatus')}:</b> <span class="status-${status}">${this.getClientStatus(status)}</span></div>
                    <div class="popup__title"><b>${this.$t('markerName')}:</b> ${name}</div>
                    <div class="popup__title"><b>${this.$t('markerFirstName')}:</b> ${first_name}</div>
                    <div class="popup__title"><b>${this.$t('markerLastName')}:</b> ${last_name}</div>
                    <div class="popup__title"><b>${this.$t('markerPhone')}:</b> ${phone_number}</div>
                    <div class="popup__title"><b>${this.$t('markerAddress')}:</b> ${address}</div>
                </div> `;
            new mapboxgl.Popup({closeOnClick: true, offset: 25 })
                .setLngLat([coordinates[0], coordinates[1]])
                .setHTML(output)
                .addTo(this.map);
        },
    }
}